const DAY_MS = 24 * 60 * 60 * 1000;

export const normalizePlanningDateOnly = (value) => {
  const dateOnly = value instanceof Date ? value.toISOString().slice(0, 10) : (value ? String(value).slice(0, 10) : '');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) return null;
  const [year, month, day] = dateOnly.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
  return dateOnly;
};

export const planningDayNumber = (value) => {
  const dateOnly = normalizePlanningDateOnly(value);
  if (!dateOnly) return null;
  const [year, month, day] = dateOnly.split('-').map(Number);
  return Math.floor(Date.UTC(year, month - 1, day) / DAY_MS);
};

export const planningDateToUtcDate = (value) => {
  const dayNumber = planningDayNumber(value);
  return dayNumber == null ? null : new Date(dayNumber * DAY_MS);
};

const dateOnlyFromDayNumber = (dayNumber) => new Date(dayNumber * DAY_MS).toISOString().slice(0, 10);

export const buildPlanningGanttTimeline = (items = [], fallbackStart, fallbackEnd) => {
  const boundaries = items.flatMap((item) => [planningDayNumber(item.startDate), planningDayNumber(item.endDate)]).filter((value) => value != null);
  const fallbackStartDay = planningDayNumber(fallbackStart);
  const fallbackEndDay = planningDayNumber(fallbackEnd);
  if (fallbackStartDay != null) boundaries.push(fallbackStartDay);
  if (fallbackEndDay != null) boundaries.push(fallbackEndDay);
  if (!boundaries.length) return null;

  const minDay = Math.min(...boundaries);
  const maxDay = Math.max(...boundaries);
  const spanDays = Math.max(1, maxDay - minDay + 1);
  const position = (value) => {
    const dayNumber = planningDayNumber(value);
    if (dayNumber == null) return null;
    return Math.max(0, Math.min(spanDays - 1, dayNumber - minDay));
  };
  return { minDay, maxDay, minDate: dateOnlyFromDayNumber(minDay), maxDate: dateOnlyFromDayNumber(maxDay), spanDays, position };
};

export const buildPlanningGanttBar = (item, timeline) => {
  if (!timeline) return null;
  const ownStart = normalizePlanningDateOnly(item?.startDate);
  const ownEnd = normalizePlanningDateOnly(item?.endDate);
  const startDate = ownStart || ownEnd;
  const endDate = ownEnd || ownStart;
  if (!startDate || !endDate) return null;
  const startOffsetDays = timeline.position(startDate);
  const endOffsetDays = timeline.position(endDate);
  const durationDays = Math.max(1, endOffsetDays - startOffsetDays + 1);
  return {
    startDate,
    endDate,
    startOffsetDays,
    endOffsetDays,
    durationDays,
    leftPercent: (startOffsetDays / timeline.spanDays) * 100,
    widthPercent: (durationDays / timeline.spanDays) * 100,
  };
};
